export default __webpack_public_path__ + "static/tanis-facebook-4b7f133992ce3fc8b11fc2f29cf4668f.jpeg";